import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana82Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
  
  <rect width="1221" height="921" fill="url(#pattern0_1462_9758)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M289.413 531.738L177.158 542.193L281.93 488.424L289.413 486.931V531.738Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M349.281 483.945L289.412 486.932V531.74L350.778 525.765L349.281 483.945Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M412.148 521.284L350.781 525.765L349.285 483.945L410.651 479.464L412.148 521.284Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M472.015 473.489L410.649 479.464L412.146 521.284L475.009 515.309L472.015 473.489Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M537.873 509.335L475.01 515.309L472.017 473.489L534.879 467.515L537.873 509.335Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M600.735 503.36L537.872 509.335L534.879 467.514L599.238 461.54L600.735 503.36Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M660.602 457.062L599.236 461.542L600.733 503.362L662.099 498.882L660.602 457.062Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M709.835 452.725L660.606 457.06L662.103 498.88L726.463 495.893C724.966 488.425 721.673 471.697 720.476 464.528C719.482 458.579 715.672 454.961 712.978 453.333C712.04 452.766 710.927 452.629 709.835 452.725Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M735.444 528.75L726.463 495.892L678.568 498.879L681.561 548.167L729.457 543.686C735.444 542.491 735.943 533.231 735.444 528.75Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M624.681 552.649L681.557 548.168L678.564 498.88L621.688 501.867L624.681 552.649Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M567.811 557.129L624.687 552.648L621.694 501.866L566.314 506.347L567.811 557.129Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M512.428 561.609L567.807 557.128L566.31 506.347L509.435 512.321L512.428 561.609Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M458.54 566.093L512.423 561.612L509.429 512.324L455.547 516.805L458.54 566.093Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M400.171 572.065L458.544 567.584L455.55 516.803L397.178 522.777L400.171 572.065Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M344.789 576.546L400.168 572.065L397.175 522.777L341.795 527.258L344.789 576.546Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M287.919 581.029L344.795 576.548L341.802 527.26L286.422 531.74L287.919 581.029Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M232.537 587.001L287.916 581.026L286.419 531.738L231.04 537.713L232.537 587.001Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M177.158 591.482L232.537 587.001L231.041 537.713L177.158 542.194V591.482Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}    
      d="M103.815 597.455L177.155 591.48V542.192L99.4514 580.231C98.4195 580.736 97.6398 581.666 97.3904 582.787C94.7938 594.466 100.484 597.455 103.815 597.455Z" 
      sfill={getFillByLot(1, selected, lands)}  
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1462_9758" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1462_9758" transform="matrix(0.00204869 0 0 0.00271602 -4.8679 -1.13252)"/>
    </pattern>
    <image id="image0_1462_9758" width="4096" height="2304" href="/mz2.png"/>
    </defs>
    </svg>

  );
};